import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/arrow-up-landing.svg'
import _imports_1 from '@/assets/images/landing/builders/logo-big-landing.svg'


const _hoisted_1 = { class: "landing" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  class: "documents-wr",
  id: "documents-wr",
  "data-aos": "fade-left"
}
const _hoisted_4 = { class: "text-wr" }
const _hoisted_5 = {
  key: 0,
  class: "document-items-wr"
}
const _hoisted_6 = ["data-aos-duration"]
const _hoisted_7 = {
  key: 0,
  class: "document-item--optional-badge"
}
const _hoisted_8 = { class: "document-item--icon-wr" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "document-label" }
const _hoisted_11 = { class: "contact-us banner" }
const _hoisted_12 = { class: "instructions-section" }
const _hoisted_13 = {
  key: 0,
  class: "how-works-text-wr",
  "data-aos": "fade-right"
}
const _hoisted_14 = {
  key: 1,
  class: "how-works-text-wr",
  "data-aos": "fade-left"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "landing-main-screen",
        "data-aos": "zoom-in"
      }, [
        _createElementVNode("div", {
          class: "landing-badge",
          "data-aos": "fade-down",
          "fade-down-duration": "500"
        }, "PARTNER WITH US"),
        _createElementVNode("div", {
          class: "landing-title",
          "data-aos": "fade-down",
          "fade-down-duration": "500"
        }, "Buyers are searching. Showcase your home designs on their preferred lots."),
        _createElementVNode("div", {
          class: "landing-sub-title",
          "data-aos": "fade-down",
          "fade-down-duration": "500"
        }, "No subscriptions. No lock-in contracts.")
      ], -1)),
      _createVNode($setup["BuilderDemo"]),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.builderLandingSectionsData, (section) => {
          return (_openBlock(), _createBlock($setup["LandingSection"], {
            animationImg: section.animationImg,
            animationText: section.animationText,
            class: _normalizeClass(section.class),
            key: section.label,
            title: section.title,
            label: section.label,
            image: `builders/${section.imageUrl}`,
            paragraphs: section.paragraphs
          }, _createSlots({ _: 2 }, [
            (section.contactUsButton)
              ? {
                  name: "button",
                  fn: _withCtx(() => [
                    _createVNode($setup["ContactUsLink"], {
                      animationName: 'fade-left',
                      toContactUsForm: false,
                      text: "TALK WITH US"
                    })
                  ]),
                  key: "0"
                }
              : undefined,
            (section.hasMoreContent)
              ? {
                  name: "button",
                  fn: _withCtx(() => [
                    _createVNode($setup["ContactUsLink"], {
                      animationName: 'fade-left',
                      text: "GET STARTED"
                    }),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "text" }, "Documents we need to start showcasing your homes", -1)),
                        _createElementVNode("img", {
                          class: _normalizeClass(["icon", { rotate: !$setup.showDocumentsItems }]),
                          src: _imports_0,
                          onClick: $setup.onShowDocumentsItems
                        }, null, 2)
                      ]),
                      ($setup.showDocumentsItems)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.builderLandingDocumentsData, (document, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "document-item",
                                "data-aos": `fade-down`,
                                "data-aos-duration": index + 4 + '00'
                              }, [
                                (document.optional)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[1] || (_cache[1] = [
                                      _createElementVNode("p", { class: "document-item--optional-badge--text" }, "OPTIONAL", -1)
                                    ]))]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_8, [
                                  _createElementVNode("img", {
                                    class: "icon",
                                    src: require(`@/assets/images/landing/builders/${document.image}`)
                                  }, null, 8, _hoisted_9)
                                ]),
                                _createElementVNode("p", _hoisted_10, _toDisplayString(document.label), 1)
                              ], 8, _hoisted_6))
                            }), 256))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  key: "1"
                }
              : undefined
          ]), 1032, ["animationImg", "animationText", "class", "title", "label", "image", "paragraphs"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _cache[3] || (_cache[3] = _createElementVNode("h2", {
        class: "contact-us--title",
        "data-aos": "fade-down"
      }, [
        _createTextVNode("Time to update your renders?"),
        _createElementVNode("span", null, "We’ve got you covered!")
      ], -1)),
      _createVNode($setup["ContactUsLink"], {
        "data-aos": "fade-down",
        text: 'GET A QUOTE'
      })
    ]),
    _createElementVNode("div", _hoisted_12, [
      ($setup.isDesktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("p", null, "Works", -1),
            _createElementVNode("p", null, "It", -1),
            _createElementVNode("p", null, "How", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("p", null, "HOW IT WORKS", -1)
          ]))])),
      _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"instructions-wr\" data-aos=\"fade-up\" data-v-4efc3eb6><div class=\"instructions-item\" data-v-4efc3eb6><div class=\"instructions-item--number-wr\" data-v-4efc3eb6><div class=\"instructions-item--number\" data-v-4efc3eb6>1</div></div><div class=\"instructions-item--text\" data-v-4efc3eb6>Tell us where you want to build</div><div class=\"dashed-line\" data-v-4efc3eb6></div></div><div class=\"instructions-item\" data-v-4efc3eb6><div class=\"instructions-item--number-wr\" data-v-4efc3eb6><div class=\"instructions-item--number\" data-v-4efc3eb6>2</div></div><div class=\"instructions-item--text\" data-v-4efc3eb6>Choose the lots you want to build on</div><div class=\"dashed-line\" data-v-4efc3eb6></div></div><div class=\"instructions-item\" data-v-4efc3eb6><div class=\"instructions-item--number-wr\" data-v-4efc3eb6><div class=\"instructions-item--number\" data-v-4efc3eb6>3</div></div><div class=\"instructions-item--text\" data-v-4efc3eb6>Send us your home designs</div><div class=\"dashed-line\" data-v-4efc3eb6></div></div><div class=\"instructions-item\" data-v-4efc3eb6><div class=\"instructions-item--number-wr\" data-v-4efc3eb6><div class=\"instructions-item--number\" data-v-4efc3eb6>4</div></div><div class=\"instructions-item--text\" data-v-4efc3eb6>Build more homes</div></div></div><img class=\"logo\" data-aos=\"fade-left\" src=\"" + _imports_1 + "\" data-v-4efc3eb6>", 2))
    ])
  ], 64))
}